export const BurgerMenu = () => (
    <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 11V9.625H17V11H0ZM0 6.1875V4.8125H17V6.1875H0ZM0 1.375V0H17V1.375H0Z" fill="#AFAFAF"/>
    </svg>
);

